import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'fuse-mail-dialog',
    templateUrl: './mail-dialog.component.html',
    styleUrls: ['./mail-dialog.component.scss'],
    standalone: false
})
export class FuseMailDialogComponent implements OnInit
{
    public confirmMessage: string;
    public titleMessage: string;

    constructor(public dialogRef: MatDialogRef<FuseMailDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data)
    {}

    ngOnInit()
    {
    }

}
